const state = {
  partnerProspectSource: null,
  iraPlanId: null,
  partnerIraProspectId: null,
};

const mutations = {
  setLeadInfo(
    state,
    { partnerProspectSource, iraPlanId, partnerIraProspectId }
  ) {
    state.partnerProspectSource = partnerProspectSource;
    state.iraPlanId = iraPlanId;
    state.partnerIraProspectId = partnerIraProspectId;
  },
};

const actions = {
  initializeLeadInfo({ commit }) {
    const leadInfo = sessionStorage.getItem("leadInfo");
    if (leadInfo) {
      commit("setLeadInfo", JSON.parse(leadInfo));
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
